module.exports = __webpack_public_path__ + "static/media/experiment-4.acd7bfac.PNG";